export default function NotFoundScreen() {
    return (
        <p>404 - Not found!</p>
    );
}